import { Skeleton } from '../../../feedback/Skeleton';
import { Flex, FlexProps } from '../../../layout/Flex';
import { BUSINESS_COVER_WIDTH } from '../constants';
import { Wrapper } from '../styles';

export const ProfileSkeleton = (props: FlexProps) => (
    <Wrapper {...props}>
        <Flex direction="row" spacing={4} width="100%" justifyContent="space-between">
            <Flex spacing={2} flex={1}>
                <Flex direction="row" spacing={2}>
                    <Skeleton variant="circular" width={80} height={80} />
                    <Flex spacing={0.25}>
                        <Skeleton variant="text" width={150} height={35} />
                        <Skeleton variant="text" width={100} height={18} />
                        <Skeleton variant="text" width={100} height={18} />
                    </Flex>
                </Flex>
                <Flex direction="row" spacing={0.75} py={1}>
                    <Skeleton variant="text" width={100} height={24} />
                    <Skeleton variant="text" width={100} height={24} />
                </Flex>
                <Flex spacing={0.25}>
                    <Skeleton variant="text" width={{ xs: 240, lg: 340, xl: 464 }} height={21} />
                    <Skeleton variant="text" width={{ xs: 240, lg: 340, xl: 464 }} height={21} />
                    <Skeleton variant="text" width={100} height={21} />
                </Flex>
                <Skeleton variant="text" width={100} height={26} />
                <Flex direction="row" spacing={1}>
                    <Skeleton variant="rect" width={150} height={40} borderRadius={3} />
                    <Skeleton variant="rect" width={150} height={40} borderRadius={3} />
                </Flex>
            </Flex>
            <Flex flexShrink={0} maxWidth="50%" borderRadius={2} overflow="hidden">
                <Skeleton variant="rect" width={BUSINESS_COVER_WIDTH} height={261} />
            </Flex>
        </Flex>
    </Wrapper>
);
